import { render, staticRenderFns } from "./bancoReactivosCargaAcademica.vue?vue&type=template&id=1eb830fc&"
import script from "./bancoReactivosCargaAcademica.vue?vue&type=script&lang=js&"
export * from "./bancoReactivosCargaAcademica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports